import { Fragment } from 'react'

import Button from '@/components/view/atoms/button/Button'
import FormLabel from '@/components/view/atoms/form/FormLabel'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import FormAlign from '@/components/view/layouts/form/FormAlign'
import FormRow from '@/components/view/layouts/form/FormRow'
import ModalContent from '@/components/view/layouts/modal/ModalContent'
import MessageBar, { MessageType } from '@/components/view/molecules/bar/MessageBar'
import ModalFooter from '@/components/view/molecules/modal/ModalFooter'

import { CsvUploadResult } from '@/components/container/form/modules/master/csvUpload/csvUploadSchema'

interface Props {
  onClickClose(): void
  result: CsvUploadResult
  onClickRedo: () => void
}

const CsvUploadResultContent = ({ result, onClickRedo, onClickClose }: Props) => {
  const errorMessages = result.messages
  return (
    <>
      {errorMessages.length > 0 ? (
        <>
          <ModalContent>
            <MessageBar type={MessageType.CRITICAL} fillIn>
              CSVファイルが取り込めませんでした。
            </MessageBar>
            <div className='ml-4 flex flex-col gap-4'>
              <FormRow direction='vertical'>
                {errorMessages.map((errorMessage, index) => (
                  <Fragment key={index}>
                    {errorMessage.rowNo ? (
                      <FormAlign>
                        <Text color={TextColor.CRITICAL} weight='bold'>
                          {errorMessage.rowNo}行目：
                        </Text>
                        <FormRow>
                          {errorMessage.messages.map((message, index) => (
                            <Text key={index} color={TextColor.CRITICAL} weight='bold'>
                              {message}
                            </Text>
                          ))}
                        </FormRow>
                      </FormAlign>
                    ) : (
                      <FormRow>
                        {errorMessage.messages.map((message) => (
                          <Text key={index} color={TextColor.CRITICAL} weight='bold'>
                            {message}
                          </Text>
                        ))}
                      </FormRow>
                    )}
                  </Fragment>
                ))}
              </FormRow>
              <FormRow direction='vertical' gap={2}>
                <FormRow align='center'>
                  <FormLabel>件数</FormLabel>
                  <Text>{result.total}</Text>
                </FormRow>
                <FormRow align='center'>
                  <FormLabel>取り込み完了</FormLabel>
                  <Text>
                    新規: {result.created} / 更新: {result.updated}
                  </Text>
                </FormRow>
              </FormRow>
            </div>
          </ModalContent>
          <ModalFooter>
            <Button
              color={'secondary'}
              size='large'
              onClick={() => {
                onClickRedo()
              }}
            >
              戻る
            </Button>
            <Button
              color={'secondary'}
              size='large'
              onClick={() => {
                onClickClose()
              }}
            >
              閉じる
            </Button>
          </ModalFooter>
        </>
      ) : (
        <>
          <ModalContent>
            <MessageBar type={MessageType.SUCCESS} fillIn>
              CSVファイルを取り込みました。
            </MessageBar>
            <FormRow direction='vertical' gap={2}>
              <FormRow align='center'>
                <FormLabel>件数</FormLabel>
                <Text>{result.total}</Text>
              </FormRow>
              <FormRow align='center'>
                <FormLabel>取り込み完了</FormLabel>
                <Text>
                  新規: {result.created} / 更新: {result.updated}
                </Text>
              </FormRow>
            </FormRow>
          </ModalContent>
          <ModalFooter>
            <Button
              color={'secondary'}
              size='large'
              onClick={() => {
                onClickClose()
              }}
            >
              閉じる
            </Button>
          </ModalFooter>
        </>
      )}
    </>
  )
}

export default CsvUploadResultContent
